// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + {"213":"codemirror","636":"returns","893":"notifications"}[chunkId] + "." + {"213":"396c27d5ac04b0cef110","636":"ed821ad626bfcea7b916","893":"5ce0f79c0c5b77b94b6f"}[chunkId] + ".css";
};